import en_header from '../../../../../locales/en-US/header.json'
import vi_header from '../../../../../locales/vi-VN/header.json'

import en_footer from '../../../../../locales/en-US/footer.json'
import vi_footer from '../../../../../locales/vi-VN/footer.json'

import en_page_employer_headhunt_service from '../../../../../locales/en-US/page_employer_headhunt_service.json'
import en_page_home_business_tag from '../../../../../locales/en-US/page_home_business_tag.json'
import vi_page_employer_headhunt_service from '../../../../../locales/vi-VN/page_employer_headhunt_service.json'
import vi_page_home_business_tag from '../../../../../locales/vi-VN/page_home_business_tag.json'

import en_label from '../../../../../locales/en-US/label.json'
import vi_label from '../../../../../locales/vi-VN/label.json'

import en_form from '../../../../../locales/en-US/form.json'
import vi_form from '../../../../../locales/vi-VN/form.json'

export default {
  en: {
    header: en_header,
    footer: en_footer,
    page_home_business_tag: en_page_home_business_tag,
    page_employer_headhunt_service: en_page_employer_headhunt_service,
    label: en_label,
    form: en_form
  },
  vi: {
    header: vi_header,
    footer: vi_footer,
    page_home_business_tag: vi_page_home_business_tag,
    page_employer_headhunt_service: vi_page_employer_headhunt_service,
    label: vi_label,
    form: vi_form
  }
}
